var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRightAlign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 4.781a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v.25a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-.25Zm-13.5 4.5a1 1 0 0 1 1-1H17a1 1 0 0 1 1 1v.25a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1v-.25Zm-4.5 4.5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v.25a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.25Z"
})));
export default SvgIconRightAlign;